import { useRef, useState } from "react";

import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Calendar } from "primereact/calendar";
import { Toast } from "primereact/toast";

import { ColaboradorDefeitoTipo } from "../components/Tabelas/ColaboradorDefeitoTipo";
import { DefeitoTurmaGrupo } from "../components/Tabelas/DefeitoTurmaGrupo";
import GraficoDefeitos from "../components/Graficos/GraficoDefeitos";
import GraficoPercentualDefeitos from "../components/Graficos/GraficoPercentualDefeito";

import Menu from "../components/Menu";

import api from "../services/api";

// Retorna o ciclo fiscal ATUAL (em andamento) com base na `date`.
// O ciclo fiscal "N" vai do dia 16 do mês (N-1) até o dia 15 do mês N 
// (mesma regra do $mesSql/$anoSql do backend). 
// Se a `date` for dia 15 ou antes, estamos no ciclo do mês atual.
// Se a `date` for depois do dia 15, já iniciou o ciclo do mês seguinte.
function getCurrentFiscalMonthYear(date) {
    const day = date.getDate();
    let month = date.getMonth() + 1; 
    let year = date.getFullYear();
    if (day > 15) {
        month += 1;
        if (month > 12) {
            month = 1;
            year += 1;
        }
    }
    return { mes: month, ano: year };
}

function fiscalMonthStart(mes, ano) {
    let month = mes - 1;
    let year = ano;
    if (month === 0) {
        month = 12;
        year -= 1;
    }
    return new Date(year, month - 1, 16); 
}

function fiscalMonthEnd(mes, ano) {
    return new Date(ano, mes - 1, 15); 
}

export default function RelatorioDefeitos() {
    const [data, setData] = useState(null);
    const [title, setTitle] = useState('');
    const [initialDate, setInitialDate] = useState(new Date());
    const [finalDate, setFinalDate] = useState(new Date());
    const [percentualDefeitos, setPercentualDefeitos] = useState(null);
    const [meta, setMeta] = useState(null);

    const toast = useRef(null);

    const handleSearch = () => {
        const formatDate = (date) =>
            `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

        const formated1 = formatDate(initialDate);
        const formated2 = formatDate(finalDate);

        api.get(`defeitos/relatorio/${formated1}/${formated2}`)
            .then((response) => {
                setData(response.data);
                setTitle(response.data.title);
                toast.current.show({ summary: "Concluído", severity: "success", detail: "Relatório gerado com sucesso." });
            })
            .catch((error) => {
                toast.current.show({
                    summary: "Ocorreu um Erro",
                    severity: "error",
                    detail: error.response ? error.response.data.message : error.message,
                });
            });

        // Define o ciclo fiscal ATUAL com base na finalDate para garantir
        // que o mês em andamento apareça no gráfico.
        // Em seguida, volta 4 meses no tempo para buscar o histórico,
        // resultando em um total de 5 meses exibidos (4 anteriores + o atual).
        const fiscalFinal = getCurrentFiscalMonthYear(finalDate);
        let mesInicial = fiscalFinal.mes - 4;
        let anoInicial = fiscalFinal.ano;
        while (mesInicial <= 0) {
            mesInicial += 12;
            anoInicial -= 1;
        }
        const dataInicialPercentual = fiscalMonthStart(mesInicial, anoInicial);
        const dataFinalPercentual = fiscalMonthEnd(fiscalFinal.mes, fiscalFinal.ano);

        api.get(
            'defeitos/relatorio-percentual-defeito',
            {
                params: {
                    data_inicial: formatDate(dataInicialPercentual),
                    data_final: formatDate(dataFinalPercentual),
                },
            }
        )
        .then((response) => {
            setPercentualDefeitos(response.data);
            setMeta(response.data.meta);
        })
        .catch((error) => {
            console.error(error);
        });
    };

    return (
        <div>
            <Menu />
            <Toast ref={toast} />
            <Card className="p-m-3" title="Relatório de Defeitos">
                <div className="p-fluid p-grid">
                    <div className="p-field p-col-12 p-md-4">
                        <Calendar
                            dateFormat="dd/mm/yy"
                            mask="99/99/9999"
                            onChange={e => setInitialDate(e.value)}
                            placeholder="Data Inicial: "
                            value={initialDate}
                        />
                    </div>
                    <div className="p-field p-col-12 p-md-4">
                        <Calendar
                            dateFormat="dd/mm/yy"
                            mask="99/99/9999"
                            onChange={e => setFinalDate(e.value)}
                            placeholder="Data Final: "
                            value={finalDate}
                        />
                    </div>
                    <div className="p-field p-col-12 p-md-4">
                        <Button
                            label="Gerar relatório"
                            onClick={handleSearch}
                        />
                    </div>
                </div>

                <div className="p-d-flex p-flex-column">
                    {data !== null && (
                        <>
                            <h4 className="p-m-1">Revisado: {Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2 }).format(data.total_revisado)}m</h4>
                            <h4 className="p-m-1">Tecelagem: {Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2 }).format(data.total_defeitos)}m</h4>
                            <h4 className="p-m-1">Percentual: {Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(data.defeitos_x_revisado)}%</h4>
                        </>
                    )}
                </div>

                <GraficoDefeitos
                    data={data}
                    title={title}
                />

                {percentualDefeitos && (
                    <GraficoPercentualDefeitos
                        data={percentualDefeitos}
                        finalDate={finalDate}
                        meta={meta}
                    />
                )}

                <DefeitoTurmaGrupo
                    data={data}
                    title={title}
                />
                <ColaboradorDefeitoTipo
                    data={data}
                />
            </Card>
        </div>
    )
}